import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/LoginView";
import Layout from "@/components/layout/Layout";
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "dashboard" */ '@/views/DashboardView'),
                meta: { 
                    title: 'Dashboard',
                }
            },
            {
                path: '/kyc-signups',
                name: 'kyc-signups',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "kyc-signups" */ '@/views/KYCSignupsView'),
            },
            {
                path: '/kazang-agents',
                name: 'kazang-agents',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "kyc-signups" */ '@/views/AgentsView.vue'),
            },
            {
                path: '/client-data',
                name: 'client-data',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "kyc-signups" */ '@/views/ClientDataView.vue'),
            },
            {
                path: '/payment-wallet',
                name: 'payment-wallet',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "payment-wallet" */ '@/views/PaymentWalletView'),
            },
            {
                path: '/payment-processing',
                name: 'paymentProcessing-blocking',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "payment-wallet" */ '@/views/PaymentProcessingBlocking'),
            },
            {
                path: '/settings',
                name: 'settings',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "payment-wallet" */ '@/views/Settings'),
            },
            {
                path: '/financial-report',
                name: 'financial-report',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "payment-wallet" */ '@/views/FinancialReports'),
            },
            {
                path: '/view-agent-request',
                name: 'view-agent-request',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "view-agent-request" */ '@/views/AgentDataView')
            },
            {
                path: '/form-management',
                name: 'form-management',
                component: () => import(/* webpackPrefetch: true, webpackChunkName: "payment-wallet" */ '@/views/FormManagment'),
            },
        ]
    },
    {
        path: '*',
        redirect: '/dashboard'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

    // if (to.name === 'login' && isAuthenticated) {
    //     return next({ name: 'dashboard' });
    // }

    if (to.name !== 'login' && !isAuthenticated) {
        return next({ name: 'login' });
    }

    next();
});


router.onError((error) => {
    if (error.message.includes('Redirected when going from')) {
        console.warn('Suppressed navigation error:', error.message);
        return;
    }
    throw error;
});

export default router
